export default "__VITE_ASSET__i4tZkBiW__"